// 导出全局web 的MaxAPI
import { overlayManager } from "../ui/overlay/overlayManager"

export const webMaxAPI = {
  overlay: {
    getReceivedData: overlayManager.getReceivedData,
    setRecordData: overlayManager.setRecordData
  },
}